import { render, staticRenderFns } from "./Fichajev2.vue?vue&type=template&id=ca5598dc"
import script from "./Fichajev2.vue?vue&type=script&lang=js"
export * from "./Fichajev2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports